import "./dashboard.scss";
import LoadingSpinner from "../loader/Loader";
import { useGetUsersQuery } from "../../features/api/userApiSlice";
import { useGetAdminVideosQuery } from "../../features/api/videoApiSlice";
import { useGetActivitiesQuery } from "../../features/api/activityApiSlice";
import { useVideo } from "../../hooks/useVideo";
import { FaUsers, FaVideo, FaDollarSign, FaUndoAlt } from "react-icons/fa";
import { MdSubscriptions } from "react-icons/md";
import { GiProfit } from "react-icons/gi";
import SubscribersChart from "./users/SubscribersChart";
import { useGetAllTransactionsQuery } from "../../features/api/transactionApiSlice";
import { useGetSubscriptionsQuery } from "../../features/api/subscriptionApiSlice";
import RevenueChart from "./TransactionsTable/RevenueChart";
import RefundsChart from "./TransactionsTable/RefundsChart";

const AdminDashboard = () => {
  const { formatDate } = useVideo();

  const { data: videos, isLoading: loadingVideos } = useGetAdminVideosQuery();
  const { data: users, isLoading: loadingUsers } = useGetUsersQuery();
  const { data: activities, isLoading: loadingActivities } =
    useGetActivitiesQuery();
  const { data: transactions, isLoading: loadingTransactions } =
    useGetAllTransactionsQuery();
  const { data: subscriptions, isLoading: loadingSubscriptions } =
    useGetSubscriptionsQuery();

  if (
    loadingVideos ||
    loadingUsers ||
    loadingActivities ||
    loadingTransactions ||
    loadingSubscriptions
  ) {
    return <LoadingSpinner />;
  }

  // --- Calculations ---
  const totalRevenue =
    transactions
      ?.filter(
        (t) => t.type === "charge" && ["captured", "settled"].includes(t.status)
      )
      .reduce((sum, t) => sum + t.amount, 0) || 0;

  const totalRefunds =
    transactions
      ?.filter((t) => t.type === "refund" || t.status === "refunded")
      .reduce((sum, t) => sum + (t.refundAmount || t.amount), 0) || 0;

  const netProfit = totalRevenue - totalRefunds;

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-top-section">
        <div className="dash-top-flex">
          <h1 className="dashboard-title">Admin Dashboard</h1>
        </div>
      </div>

      {/* --- KPI STAT CARDS --- */}
      <div className="dashboard-stats grid-5">
        <div className="stat-card">
          <FaVideo className="stat-icon" />
          <div>
            <h2>{videos?.length}</h2>
            <p>Total Videos</p>
          </div>
        </div>
        <div className="stat-card">
          <FaUsers className="stat-icon" />
          <div>
            <h2>{users?.length}</h2>
            <p>Total Users</p>
          </div>
        </div>
        <div className="stat-card">
          <MdSubscriptions className="stat-icon" />
          <div>
            <h2>{subscriptions?.length}</h2>
            <p>Active Subscriptions</p>
          </div>
        </div>
        <div className="stat-card">
          <FaDollarSign className="stat-icon" />
          <div>
            <h2>${totalRevenue.toFixed(2)}</h2>
            <p>Total Sales</p>
          </div>
        </div>
        <div className="stat-card">
          <FaUndoAlt className="stat-icon" />
          <div>
            <h2>${totalRefunds?.toFixed(2)}</h2>
            <p>Total Refunds</p>
          </div>
        </div>
        <div className="stat-card">
          <GiProfit className="stat-icon" />
          <div>
            <h2>${netProfit?.toFixed(2)}</h2>
            <p>Net Profit</p>
          </div>
        </div>
      </div>

      {/* --- CHARTS & OVERVIEWS --- */}
      <div className="dash-flex">
        {/* <div className="recent-activity">
          <div className="activities-top-flex">
            <h2>Recent Activity</h2>
            <button>View All</button>
          </div>
          {activities?.slice(0, 5)?.map((activity) => (
            <div key={activity?._id} className="activity-item">
              <p style={{ fontWeight: "500" }}>{activity?.type}</p>
              <p>{activity?.details}</p>
              <span>{formatDate(activity?.timestamp)}</span>
            </div>
          ))}
        </div> */}

        <div className="recent-activity">
          <h2>Subscribers Overview</h2>
          <SubscribersChart users={users || []} />
        </div>
      </div>

      <div className="dash-flex">
        <div className="recent-activity">
          <h2>Revenue Overview</h2>
          <RevenueChart transactions={transactions || []} />
        </div>
        <div className="recent-activity">
          <h2>Refunds Overview</h2>
          <RefundsChart
            refunds={
              transactions?.filter(
                (t) => t.type === "refund" || t.status === "refunded"
              ) || []
            }
          />
        </div>
      </div>

      <div className="dash-flex">
        <div className="recent-activity wide">
          <h2>Revenue Trends</h2>
          <RevenueChart transactions={transactions || []} />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
